import React, {useState} from 'react';

import {translate} from 'iss/strings';
import {useQueryState} from 'iss/hooks/useQueryState';
import {searchActivations} from 'iss/service/EvaluationActivationService';
import {hasAdminRole} from 'iss/service/PartyService';
import {ActivationList} from 'iss/widgets/ActivationList';
import {EditButton} from 'iss/widgets/Buttons';
import {FlexItem, FlexRow} from 'iss/widgets/Flex';
import {PagedSearchResults, SearchResultScroller, ShowAllResultsButton, TextSearchBar, formatResultCount} from 'iss/widgets/PagedSearchResults';
import {ActivationBatchOpChooser} from 'iss/widgets/batchOps/ActivationBatchOps';
import {BatchOpRunnerDialog} from 'iss/widgets/batchOps/BatchOpRunnerDialog';
import BootstrapCheckbox from 'iss/widgets/bootstrap/Checkbox';
import { SortOrderEnum } from '../widgets/SortColumnHeader';

function ActivationListPage() {
  const [search, setSearch] = useQueryState({
    defaults: {query: "", showArchived: false, sortFieldName: "ID", sortOrder: SortOrderEnum.ASCENDING},
    parse: {showArchived: val => val == "true"}
  });
  const [selected, setSelected] = useState([]);
  const [currentBatchOp, selectBatchOp] = useState(null);
  const getItems = (search, page, size) => {
    return searchActivations(search.query, search.showArchived, search.sortFieldName, search.sortOrder, page, size, false);
  };

  return <React.Fragment>
    <h1>
      {translate(hasAdminRole() ? 'activationList.adminTitle' : 'activationList.title')}
    </h1>
    <ActivationSearch search={search} onChange={setSearch}/>
    <PagedSearchResults getItems={getItems} search={search}>
      {(results, resultApi) =>
        <React.Fragment>
          <ActivationResultCount searchResult={results} selectedActivations={selected} onSelectBatchOp={selectBatchOp} onShowAll={resultApi.loadAllItems} />
          <SearchResultScroller searchResult={results} onLoadMore={resultApi.loadMoreItems}>
            <ActivationSearchResults activations={results.results} selected={selected} onChangeSelected={setSelected} search={search} onChangeSort={setSearch} />
          </SearchResultScroller>
          <BatchOpRunnerDialog operation={currentBatchOp} operationTargets={selected}
            onClose={() => selectBatchOp(null)}
            onOperationDone={() => { selectBatchOp(null); setSelected([]); resultApi.reload(); }}
          />
        </React.Fragment>
      }
    </PagedSearchResults>
  </React.Fragment>;
}

function ActivationSearch({search, onChange}) {
  const {query, showArchived} = search;
  return <TextSearchBar id="activation-search" search={query}
    onChange={(newQuery) => onChange({showArchived, query: newQuery})} >
    {hasAdminRole() &&
        <BootstrapCheckbox id="showArchived" className="text-nowrap"
          label="activationList.showArchived"
          value={showArchived} onChange={(e) => onChange({query, showArchived: Boolean(e.target.checked)})} />
    }
  </TextSearchBar>;
}

function ActivationResultCount({searchResult, selectedActivations, onSelectBatchOp, onShowAll}) {
  return <FlexRow alignItems="center" minHeight="3em">
      <FlexItem flex="none">
        {formatResultCount(searchResult)}
        <ShowAllResultsButton searchResult={searchResult} onShowAll={onShowAll} />
      </FlexItem>
      <FlexItem flex="none" className="form-inline">
        <ActivationToolbar selectedActivations={selectedActivations} onChoose={onSelectBatchOp}/>
      </FlexItem>
    </FlexRow>;
}

function ActivationToolbar({selectedActivations, onChoose}) {
  if (!selectedActivations.length) return null;

  return <React.Fragment>
    {translate('activationList.editSelected') + " "}
    <ActivationBatchOpChooser onChoose={onChoose} />
  </React.Fragment>;
}

function ActivationSearchResults(props) {
  return <ActivationList {...props} selectable={true} extraColumnsFirst={true} extraColumns={[
    {
      header: translate('common.edit'),
      accessor: activation =>
      <EditButton className="edit-activation" id={"edit-activation-"+activation.id}
        canEdit={activation.isActive}
        link={"/activatedEvaluations/"+activation.id}
        alt={translate('activationList.editActivation')}
      />
    }
  ]}/>;
}

export default ActivationListPage;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/ActivationListPage.jsx